
import React from 'react';


const Video = () => {

  return <svg 
	aria-hidden='true' 
	focusable='false' 
	data-prefix='fas' 
	data-icon='video' 
	className='iconSVG'
	role='img' 
	xmlns='http://www.w3.org/2000/svg' 
	viewBox='0 0 576 512'>
	<path 
	  d='M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z'>
	</path>
  </svg>;
};

export default Video;